import { render, staticRenderFns } from "./viewmore.vue?vue&type=template&id=3b1ebae2&scoped=true"
import script from "./viewmore.vue?vue&type=script&lang=js"
export * from "./viewmore.vue?vue&type=script&lang=js"
import style0 from "./viewmore.vue?vue&type=style&index=0&id=3b1ebae2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1ebae2",
  null
  
)

export default component.exports